import { ParticipantRole } from '@breathelife/types';

import ApiService from './ApiService';

export async function fetchParticipantRoles(): Promise<ParticipantRole[]> {
  const response = await ApiService.fetchParticipantRoles();
  return response.data;
}
